(function ($) {
    $.fn.extend({
        vinnybox: function (options) {

            var defaults = {
                fadeSpeed: 500,
                autoplaySpeed: 5000,
                autoplay: false,
                navShape: 'round',
                navBackground: 'rgba(0,0,0,0.5)',
                navColor: '#ffffff',
                vinnyboxBackground: 'rgba(0,0,0,0.5)'
            };

            options = $.extend(defaults, options);

            var gallery;
            var autoplay;
            var autoplayResume;
            var currentImage;
            var htmlContainer = $('<div class="vinnybox-container" style="background-color: '+options.vinnyboxBackground+'"></div>');
            var htmlNav = $('<div class="vinnybox-nav">' +
                '<button class="vinnybox-nav-btn vinnybox-next" aria-label="Next" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" aria-hidden="true"><path d="M.29.29C.65-.07,1.22-.1,1.61.21l.09.08,5,5c.36.36.39.93.08,1.32l-.08.09L1.71,11.71c-.39.39-1.02.39-1.41,0-.36-.36-.39-.93-.08-1.32l.08-.09,4.29-4.29L.29,1.71C-.07,1.35-.1.78.21.39l.08-.09Z" fill="currentColor" stroke-width="0"/></svg></button>' +
                '<button class="vinnybox-close vinnybox-nav" aria-label="Close" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" width="14.61" height="14.61" viewBox="0 0 14.61 14.61" aria-hidden="true"><path d="M8.72,7.31L14.32,1.71c.39-.39.39-1.02,0-1.41s-1.02-.39-1.41,0l-5.6,5.6L1.71.29C1.32-.1.68-.1.29.29S-.1,1.32.29,1.71l5.6,5.6L.29,12.9c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l5.6-5.6,5.6,5.6c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41l-5.6-5.6Z" fill="currentColor" stroke-width="0"/></svg></button>' +
                '<button class="vinnybox-nav-btn vinnybox-prev" aria-label="Previous" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="14.16" viewBox="0 0 18 14.16" aria-disabled="true"><path d="M3.08,7.96h14.09c.23-.02.44-.12.59-.28.15-.16.24-.37.24-.59s-.09-.43-.24-.59c-.15-.16-.36-.26-.59-.28H3.08L7.87,1.56c.1-.08.18-.18.24-.29.06-.11.09-.23.1-.35,0-.12-.01-.25-.06-.36-.05-.12-.12-.22-.21-.31-.09-.09-.2-.15-.32-.2-.12-.04-.25-.06-.37-.05-.13,0-.25.04-.36.1-.11.06-.21.14-.29.23L.26,6.47c-.16.16-.26.38-.26.61s.09.45.26.61l6.33,6.13c.08.1.18.18.29.24.11.06.24.09.36.1.13,0,.26-.01.38-.05.12-.04.23-.11.32-.2.09-.09.16-.19.21-.31.05-.12.07-.24.06-.36,0-.12-.04-.24-.1-.36-.06-.11-.14-.21-.24-.29L3.07,7.96h0Z" fill="currentColor" stroke-width="0"/></svg></button>' +
                '</div>');
            var htmlClose = $('<div class="vinnybox-nav">' +
                '<button class="vinnybox-close vinnybox-nav" aria-label="Close" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" width="14.61" height="14.61" viewBox="0 0 14.61 14.61" aria-hidden="true"><path d="M8.72,7.31L14.32,1.71c.39-.39.39-1.02,0-1.41s-1.02-.39-1.41,0l-5.6,5.6L1.71.29C1.32-.1.68-.1.29.29S-.1,1.32.29,1.71l5.6,5.6L.29,12.9c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l5.6-5.6,5.6,5.6c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41l-5.6-5.6Z" fill="currentColor" stroke-width="0"/></svg></button>' +
                '</div>');
            var vinnybox = $(this);
            var thisElem;

            // GET OBJECT TYPE FUNCTION
            $.fn.getObjectType = function(){
                return $(this)[0].tagName;
            };

            // GET IMAGE URL FUNCTION
            $.fn.getImageUrl = function(){
                if ($(this).data('image')) {
                    return $(this).data('image');
                }
                if ($(this).getObjectType() == 'IMG') {
                    return $(this).attr('src');
                }
                if ($(this).getObjectType() == 'DIV') {
                    var img = ($(this).css('background-image'));
                    var url = img.match(/\((['"]?)(.*?)(['"]?)\)/);
                    return url[2];
                }
            };

            // VINNYBOX PLAY FUNCTION
            $.fn.vinnyboxPlay = function(total){
                autoplay = setInterval(function(){
                    $('[data-index='+currentImage+']').fadeOut(options.fadeSpeed);
                    currentImage++;
                    if (currentImage == total) {
                        currentImage = 0;
                    }
                    $('[data-index='+currentImage+']').fadeIn(options.fadeSpeed);
                }, options.autoplaySpeed)
            };

            // ADD NAV FUNCTION
            $.fn.addNav = function(){
                htmlNav.appendTo($(this));
            };

            // ADD CLOSE FUNCTION
            $.fn.addClose = function(){
                htmlClose.appendTo($(this));
            };

            // GET YOUTUBE ID
            function getYoutubeId($string) {
                if ($string.indexOf('=') > 0) {
                    if ($string.indexOf('&')) {
                        return $string.split('=')[1].split('&')[0];
                    }
                    return $string.split('=')[1];
                } else {
                    return $string.split('/').pop();
                }
            }

            // GET VIMEO ID
            function getVimeoId($string) {
                return $string.split('/').pop();
            }

            // NAV SWIPE AND CLICK CLOSE
            var x;

            function dragStart(startX) {
                x = startX;

                if (container.hasClass('swipe')) {
                    container.removeClass('swipe');
                }
            }

            function dragEnd(event, endX, endThis) {
                if (endX < x - 30 && gallery.length > 1) {
                    vinnyboxPause();
                    vinnyboxPrev(gallery.length);
                    container.addClass('swipe');
                } else if (endX > x + 30 && gallery.length > 1) {
                    vinnyboxPause();
                    vinnyboxNext(gallery.length);
                    container.addClass('swipe');
                } else if (event.target == endThis) {
                    vinnyboxClose();
                }
            }

            var setInteractions = function() {
                container.on({
                    mousedown: function(event){
                        dragStart(event.clientX)
                    },
                    mouseup: function(event){
                        dragEnd(event, event.clientX, this)
                    },
                    touchstart: function(event){
                        dragStart(event.touches[0].clientX)
                    },
                    touchend: function(event){
                        dragEnd(event, event.changedTouches[0].clientX, this)
                    },
                })
            }

            // NEXT SLIDE
            var vinnyboxNext = function(total){
                let currentSlide = $('[data-index='+currentImage+']');
                currentSlide.fadeOut(options.fadeSpeed, function(){
                    currentSlide.find('iframe').each(function(){
                        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
                    })
                });

                currentImage++;
                if (currentImage == total) {
                    currentImage = 0;
                }

                let nextSlide = $('[data-index='+currentImage+']');
                nextSlide.fadeIn(options.fadeSpeed, function(){
                    nextSlide.find('iframe').each(function() {
                        this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
                    });
                });
            }
            // PREV SLIDE
            var vinnyboxPrev = function(total){
                let currentSlide = $('[data-index='+currentImage+']');
                currentSlide.fadeOut(options.fadeSpeed, function(){
                    currentSlide.find('iframe').each(function(){
                        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
                    })
                });

                currentImage--;
                if (currentImage == -1) {
                    currentImage = total - 1;
                }

                let nextSlide = $('[data-index='+currentImage+']');
                nextSlide.fadeIn(options.fadeSpeed, function(){
                    nextSlide.find('iframe').each(function() {
                        this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
                    });
                });
            }

            // PAUSE AUTOPLAY
            var vinnyboxPause = function(){
                if (options.autoplay == true) {
                    clearInterval(autoplay);
                    clearTimeout(autoplayResume);

                    autoplayResume = setTimeout(function(){
                        container.vinnyboxPlay(gallery.length);
                    }, options.autoplaySpeed);
                }
            };

            // NAVIGATION
            $.fn.vinnyboxNav = function(total){

                vinnyboxPause();

                // NAVIGATE
                if ($(this).hasClass('vinnybox-next')){
                    vinnyboxPause();
                    vinnyboxNext(total);
                } else {
                    vinnyboxPause();
                    vinnyboxPrev(total);
                }
            };

            // CLOSE LIGHTBOX
            var vinnyboxClose = function(){
                clearInterval(autoplay);
                clearTimeout(autoplayResume);
                container.fadeOut(options.fadeSpeed, function(){
                    container.empty();
                    currentImage = '';
                });
            };

            // CREATE ARRAY OF IMAGES
            var createGallery = function($id){
                if ($id){
                    gallery = vinnybox.filter('[data-gallery='+$id+']:not(.slick-cloned)').map(function () {
                        return {
                            'image': $(this).getImageUrl()
                        };
                    });
                } else {
                    gallery = [{
                        'image': thisElem.getImageUrl()
                    }];
                }
            };

            // CREATE LIGHTBOX CONTAINER
            if (vinnybox.length){
                htmlContainer.appendTo('body').hide();
                var container = $('.vinnybox-container');

                // SET INTERACTIONS
                setInteractions()
            }

            // ADD VINNYBOX CLASS FOR CSS
            if (!vinnybox.hasClass('vinnybox')) {
                vinnybox.addClass('vinnybox');
            }

            // ON VINNYBOX CLICK
            vinnybox.on('click', function(){
                thisElem = $(this);

                if (vinnybox.closest('.slick-slider').hasClass('isSliding')) {
                    return;
                }

                var $id = thisElem.data('gallery'),
                    autoplay;

                createGallery($id);

                container.fadeIn(options.fadeSpeed);

                var thisUrl = thisElem.getImageUrl();
                for (var i = 0; i < gallery.length; i++) {

                    if (thisUrl == gallery[i]["image"]) {
                        currentImage = i;
                        autoplay = 1
                    } else {
                        autoplay = 0
                    }

                    if (gallery[i]["image"].indexOf('youtu') > 0) {

                        $('<div class="iframe-container" data-index="'+i+'"><iframe width="560" height="315" src="https://www.youtube.com/embed/'+ getYoutubeId(gallery[i]["image"]) +'?autoplay='+ autoplay +'&enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>').appendTo(container).hide();

                    } else if (gallery[i]["image"].indexOf('vimeo') > 0) {
                        $('<div class="iframe-container" data-index="'+i+'"><iframe src="https://player.vimeo.com/video/'+ getVimeoId(gallery[i]["image"]) +'?autoplay='+ autoplay +'" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>').appendTo(container).hide();

                    } else {
                        $('<img src="'+gallery[i]["image"]+'" data-index="'+i+'" />').appendTo(container).hide();
                    }
                }

                $('[data-index='+currentImage+']').fadeIn(options.fadeSpeed);

                // SETUP NAV
                if (gallery.length > 1) {
                    container.addNav();

                    $('.vinnybox-nav-btn').on('click', function(){
                        $(this).vinnyboxNav(gallery.length);
                    });
                } else {
                    container.addClose();
                }

                let close = $('.vinnybox-close'),
                    next = $('.vinnybox-next'),
                    prev = $('.vinnybox-prev');

                next.focus();

                close.on('click', function(){
                    vinnyboxClose();
                });

                next.on('keydown', function(e){
                    if (e.shiftKey && e.keyCode == 9) {
                        e.preventDefault();
                        prev.focus();
                    }
                });

                prev.on('keydown', function(e) {
                    if (e.keyCode == 9 && !e.shiftKey) {
                        e.preventDefault();
                        next.focus();
                    }
                })

                $('.vinnybox-close, .vinnybox-nav-btn').on('keydown', function(e){
                    if (e.keyCode == 27) {
                        vinnyboxClose();
                    }
                })

                // SETUP AUTOPLAY
                if (options.autoplay == true && gallery.length > 1 ){
                    container.vinnyboxPlay(gallery.length);
                }
            });
        }
    });
})(jQuery);
